import { Route } from 'react-router-dom'
import { AccountSelectorPage } from '~/@biz_account/account-selector/AccountSelectorPage'
import { PhoneLoginPage } from '~/@biz_account/phone-login/PhoneLoginPage'
import { PhoneRegisterInvestorPage } from '~/@biz_account/phone-register-investor/PhoneRegisterInvestorPage'
import { PhoneRegisterOwnerPage } from '~/@biz_account/phone-register-owner/PhoneRegisterOwnerPage'

export const AccountRoutes = () => {
  return (
    <>
      <Route path="" element={<PhoneLoginPage />} />
      <Route path="register" element={<AccountSelectorPage />} />
      <Route path="register/investor" element={<PhoneRegisterInvestorPage />} />
      <Route path="register/vlastnik" element={<PhoneRegisterOwnerPage />} />
    </>
  )
}
